import type { Building } from "building-types/building/buildingTypes";
import { floorAreaTakeoffsGetConditionedArea } from "doc/elements/floorAreaTakeoffs/takeoffs";

export function buildingGetConditionedArea(building: Building | null | undefined): number {
  return building ? floorAreaTakeoffsGetConditionedArea(building.floorAreaTakeoffs) : 0;
}
